module.exports = __webpack_public_path__ + "static/media/firebase.0b054ebd.png";